import React, { useState, useEffect, useRef } from 'react';
 import { toast } from 'react-toastify';

function CustomerField({ value, onSelect }) {
  const [input, setInput] = useState('');
  const [options, setOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newPhone, setNewPhone] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const containerRef = useRef(null);
  const ignoreNextSearch = useRef(false); // <== ΝΕΟ
  const hasAutoExtractedPhone = useRef(false);
  const [phoneError, setPhoneError] = useState('');
  const [nameError, setNameError] = useState('');


 


  // Sync με selected value από parent
  useEffect(() => {
    if (!value) {
      setInput('');
    } else {
      setInput(value.name);
    }
  }, [value]);

  // Click έξω => κλείνει dropdown
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOptions([]);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);



  useEffect(() => {
  if (showModal) {
    setPhoneError('');
    setNameError('');
    setNewEmail('');
    setWantsSMS(false);
    setWantsEmail(false);
  }
}, [showModal]);

  // Fetch πελατών
useEffect(() => {
  if (ignoreNextSearch.current) {
    ignoreNextSearch.current = false;
    return;
  }

  const trimmed = input.trim();

  if (trimmed.length < 2) {
    setOptions([]);
    return;
  }

  const controller = new AbortController();

  fetch(`https://api.remindly.gr/get-customers.php?search=${trimmed}`, {
    credentials: 'include',
    signal: controller.signal,
  })
    .then((res) => res.json())
    .then((data) => {
      const digits = trimmed.replace(/\D/g, '');
      const words = trimmed.replace(/[0-9]/g, '').trim();
      const hasValidPhone = digits.length === 10;

      // ✅ Αποθήκευση κινητού μόνο ΜΙΑ φορά
 if (data.length === 0 && hasValidPhone && !hasAutoExtractedPhone.current) {
  setNewPhone(digits);

  if (words.length === 0) {
    setInput('');
  } else {
    setInput(words);
  }

  setShowModal(true); // 💥 Ενεργοποιεί τη φόρμα!
  hasAutoExtractedPhone.current = true;
  return;
}



      // ✅ Φιλτράρισμα ώστε να μην εμφανίζονται αποτελέσματα με ίδιο όνομα αλλά διαφορετικό κινητό
      const filteredData = data.filter(c => {
        if (!hasValidPhone) return true; // δείξε τα όλα αν δεν έχεις τηλέφωνο
        return c.phone === digits; // δείξε μόνο όποιον έχει και ίδιο κινητό
      });

      setOptions(filteredData);
      setShowModal(filteredData.length === 0);
    })
    .catch((err) => {
      if (err.name !== 'AbortError') console.error(err);
    });

  return () => controller.abort();
}, [input]);



  const handleSelect = (cust) => {
    ignoreNextSearch.current = true; // <== Αποφυγή άσκοπου fetch
    setInput(cust.name);
    setOptions([]);
    setShowModal(false);
    onSelect(cust);
    setNewPhone('');
    setNewEmail('');
  };

  const isValidEmail = (email) => {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};


  const handleNewCustomer = () => {

  if (!input.trim()) {
      setNameError("Το όνομα πελάτη είναι υποχρεωτικό.");
      toast.error("Το όνομα πελάτη δεν μπορεί να είναι κενό.");
      return;
    } else {
      setNameError('');
    }



   if (!/^69\d{8}$/.test(newPhone)) {
  setPhoneError("Το κινητό πρέπει να ξεκινά με 69 και να έχει 10 ψηφία.");
  toast.error("Το κινητό πρέπει να ξεκινά με 69 και να έχει 10 ψηφία.");
  return;
} else {
  setPhoneError('');
}


    if (newEmail.trim() && !isValidEmail(newEmail)) {
      toast.error("Το email δεν είναι έγκυρο.");
      return;
    }


    fetch('https://api.remindly.gr/check-phone.php', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ phone: newPhone }),
})
  .then((res) => res.json())
  .then((data) => {
    if (data.exists) {
      toast.error(`Το κινητό ανήκει ήδη στον πελάτη: ${data.customer.name}`);
      return;
    }

    // 👉 Αν όλα ΟΚ, συνεχίζουμε με κανονικό fetch για καταχώριση
fetch('https://api.remindly.gr/add-customer.php', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  credentials: 'include', // ✅ για αποστολή cookie και ενεργό session
  body: JSON.stringify({
    name: input,
    phone: newPhone,
    email: newEmail,
    wants_sms: wantsSMS ? 1 : 0,
    wants_email: wantsEmail ? 1 : 0
    // ❌ Μην στείλεις business_id – το παίρνει από το session!
  }),
})


      .then((res) => res.json())
      .then((data) => {
        if (data.success || data.existing) {
            const cust = data.customer ?? {
            id: data.id ?? data.customer_id,
            name: input,
            phone: newPhone,
            email: newEmail,
            notes: ""
          };
          handleSelect(cust);
          setShowModal(false);
        } else {
          toast.error("❌ Σφάλμα κατά την καταχώριση πελάτη");
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        toast.error("Σφάλμα επικοινωνίας με τον server");
      });
  });




  };

  const [wantsSMS, setWantsSMS] = useState(false);
  const [wantsEmail, setWantsEmail] = useState(false);


return (
  <div ref={containerRef} className="relative w-full">
    <input
      type="text"
      placeholder="Πελάτης"
      value={input}
      onChange={(e) => {
        setInput(e.target.value);
        onSelect(null);
      }}
      required
      className={`w-full border rounded p-2 bg-gray-100 text-gray-600 ${
  nameError ? 'border-red-500' : 'border-gray-300'
      }`}

      

      onFocus={() => {
        if (!value) setShowModal(false); // dropdown εμφανίζεται μόνο όταν δεν υπάρχει value
      }}
    />
    {nameError && (
  <div className="text-red-600 text-sm mt-1">{nameError}</div>
)}

    {/* ✕ Clear button αν έχει value */}
    {value && (
      <button
        type="button"
onClick={() => {
  onSelect(null);
  setInput('');
  setOptions([]);
  hasAutoExtractedPhone.current = false;
  setWantsSMS(false);
  setWantsEmail(false);
}}


        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 z-10"
      >
        ×
      </button>
    )}

    {/* Dropdown επιλογών */}
    {options.length > 0 && !value && (
      <ul className="absolute left-0 mt-1 border border-gray-300 bg-white rounded shadow z-20 w-[max(100%,30rem)]">
        {options.map((cust) => (
          <li
            key={cust.id}
            onMouseDown={() => handleSelect(cust)}
            className="cursor-pointer px-3 py-1 hover:bg-gray-100 border-b last:border-none"
          >
            {cust.name} – {cust.phone}
          </li>
        ))}
      </ul>
    )}

    {/* Modal νέου πελάτη */}
    {showModal && !value && (
      <div className="absolute left-0 mt-2 w-full max-w-5xl border border-gray-300 bg-gray-50 p-4 rounded-lg shadow z-20 sm:w-[95vw] lg:w-[calc(100vw-5rem)]">

        <h4 className="font-semibold mb-2">➕ Νέος Πελάτης</h4>

<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-3">
  <div className="w-full">
    <input
      type="text"
      value={input}
      readOnly
      className="w-full border border-gray-300 rounded p-2 bg-gray-100 text-gray-600"
    />
  </div>

  <div className="w-full">
    <input
      type="text"
      placeholder="Κινητό"
      value={newPhone}
      onChange={(e) => {
        const raw = e.target.value.replace(/\D/g, ''); // κρατά μόνο αριθμούς
        if (raw.length <= 10) {
          setNewPhone(raw);
        }
      }}
      required
      className={`w-full rounded p-2 mb-1 border ${
  phoneError ? 'border-red-500' : 'border-gray-300'
}`}
    />

    {phoneError && (
  <div className="text-red-600 text-sm mt-1">{phoneError}</div>
)}

<label htmlFor="sms-toggle" className="flex items-center gap-2 text-sm cursor-pointer select-none">
  <span>Αποστολή SMS</span>
  <div className="relative w-10 h-5">
    <input
      id="sms-toggle"
      type="checkbox"
      checked={wantsSMS}
      onChange={() => setWantsSMS(!wantsSMS)}
      className="sr-only peer"
    />
    <div className="w-10 h-5 bg-gray-300 rounded-full peer-checked:bg-green-500 transition-colors"></div>
    <div className="absolute top-0 left-0 w-5 h-5 bg-white rounded-full shadow-md transition-transform peer-checked:translate-x-5"></div>
  </div>
</label>

  </div>

  <div className="w-full">
    <input
      type="email"
      placeholder="Email (προαιρετικό)"
      value={newEmail}
      onChange={(e) => setNewEmail(e.target.value)}
      className="w-full border border-gray-300 rounded p-2 mb-2"
    />
<label htmlFor="email-toggle" className="flex items-center gap-2 text-sm cursor-pointer select-none">
  <span>Αποστολή Email</span>
  <div className="relative w-10 h-5">
    <input
      id="email-toggle"
      type="checkbox"
      checked={wantsEmail}
      onChange={() => {
        if (!newEmail.trim()) {
          toast.error("Δεν έχει εισαχθεί email.");
          return;
        }
        setWantsEmail(!wantsEmail);
      }}
      className="sr-only peer"
    />
    <div className="w-10 h-5 bg-gray-300 rounded-full peer-checked:bg-indigo-500 transition-colors"></div>
    <div className="absolute top-0 left-0 w-5 h-5 bg-white rounded-full shadow-md transition-transform peer-checked:translate-x-5"></div>
  </div>
</label>

  </div>
</div>


     

        <div className="flex gap-2">
          <button
            onClick={handleNewCustomer}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
          >
            Καταχώριση
          </button>
<button
  onClick={() => {
    setShowModal(false);
    setInput('');
    setNewPhone('');
    setNewEmail('');
    hasAutoExtractedPhone.current = false;
    setPhoneError('');
    setNameError('');
    setOptions([]);
  }}
  className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded"
>
  Άκυρο
</button>



        </div>
      </div>
    )}
  </div>
);

}

export default CustomerField;
